import { useEffect, useContext, useState } from "react";
import { get, post } from "../../../../adapters/xhr/api";
import Moment from "moment";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import { DatePickerFormatedWithLimit } from "../../../../shared/form/DatePickerFormated";
import { useLocation } from "react-router-dom";

const MineQuarryForm = ({
  generateOptions,
  residentialUnitTypes,
  error_new_user,
  setValidFields,
  handleChangeDeclerationUnit,
  deedOfExploitationFileInputRef,
  setUploadFileError,
  setError,
  fileInputKeys,
  DownloadFile,
  handlePreviewFile,
  setTempFiles,
}) => {
  const location = useLocation();
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const { declarationRequest, updateDeclarationUnit, setDeclarationRequest } =
    unifiedTaxDeclarationContext;
  const [facilityTypes, setFacilityTypes] = useState([]);
  const [materials, setMaterials] = useState([]);

  const [contractStartDate, setContractStartDate] = useState(null);
  const [contractEndDate, setContractEndDate] = useState(null);
  const [fileErrors, setFileErrors] = useState({});

  const getLookups = async () => {
    try {
      let url =
        "api/declaration-system/declaration-lookups/mineQuarry-facility-lookups";

      const [lookupRes] = await Promise.all([get(url)]);

      setFacilityTypes(lookupRes?.data?.data?.mine_quarry_facility_types);
      setMaterials(lookupRes?.data?.data?.mine_quarry_materials);
    } catch (error) {
      console.error("Initialization error:", error);
    }
  };

  useEffect(() => {
    getLookups();
  }, []);

  useEffect(() => {
    if (
      declarationRequest?.unit?.id &&
      (declarationRequest?.viewMode || declarationRequest?.editMode)
    ) {
      setContractStartDate(new Date(declarationRequest?.unit?.contract_start));
      setContractEndDate(new Date(declarationRequest?.unit?.contract_end));
    }
  }, []);

  const formFields = ({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  }) => [
    {
      type: "select",
      colClass: "col-md-4",
      name: "facility_type_id",
      labelText: "نوع المنشأة",
      labelHtmlFor: "facility_type_id",
      options: generateOptions(facilityTypes),
      defaultText: "أختار نوع المنشأة..",
      value: declarationRequest?.unit?.facility_type_id,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.facility_type_id,
      stylesRequestData,
      required: true,
      valueType: "string",
    },
    {
      type: "select",
      colClass: "col-md-4",
      name: "extracted_material_id",
      labelText: "نوع المادة المستخرجة",
      labelHtmlFor: "extracted_material_id",
      options: generateOptions(materials),
      defaultText: "أختار نوع المادة المستخرجة..",
      value: declarationRequest?.unit?.extracted_material_id,
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.extracted_material_id,
      stylesRequestData,
      required: true,
      valueType: "string",
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "licensed_area",
      labelText: "المساحة المرخص بها ",
      placeholder: "ادخل المساحة المرخص بها ..",
      labelHtmlFor: "licensed_area",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.licensed_area || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.licensed_area,
      stylesRequestData,
      required: true,
    },

    {
      type: "input",
      colClass: "col-md-4",
      name: "annual_rent_value",
      labelText: "القيمة الإيجارية السنوية أو قيمة الإنتفاع أو الإستغلال",
      placeholder:
        "ادخل القيمة الإيجارية السنوية أو قيمة الإنتفاع أو الإستغلالة..",
      labelHtmlFor: "annual_rent_value",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.annual_rent_value || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.annual_rent_value,
      stylesRequestData,
      required: false,
    },
  ];

  const fields = formFields({
    declarationRequest,
    error_new_user,
    residentialUnitTypes,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  });

  const handleChangeUnitFile = async (pc, c, key, value, i, bi, fi, ref) => {
    try {
      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: response?.data?.data,
        // }));
        updateDeclarationUnit(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        setFileErrors((prev) => ({ ...prev, [key]: "" }));
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: null,
        // }));
        updateDeclarationUnit(key, null);
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
        setFileErrors((prev) => ({
          ...prev,
          [key]: error?.response?.data?.errors?.file?.[0] || "خطأ في الملف",
        }));
        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  const handleDateChange = (parentCompenent, compenent, key, value) => {
    let keyInUnit;
    if (key === "contractStartDate") {
      setContractStartDate(value);
      keyInUnit = "contract_start";
      setContractEndDate(null);
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: {
          ...prev.unit,
          contract_end: null,
        },
      }));
    } else {
      setContractEndDate(value);
      keyInUnit = "contract_end";
    }
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        [keyInUnit]: Moment(value).format("yyyy-MM-DD"),
      },
    }));
    // updateDeclarationUnit(key, Moment(value).format("yyyy-MM-DD"));
  };

  const attachedEssentialDocuments = [
    {
      key: "deed_of_exploitation",
      label: "مرفق سند الإنتفاع أو الإستغلال",
      file: declarationRequest?.unit?.deed_of_exploitation,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  return (
    <>
      {fields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      {declarationRequest?.viewMode || declarationRequest?.isUnitViewMode ? (
        <div className="col-lg-4 col-sm-6">
          <InputElement
            value={declarationRequest?.unit?.contract_start}
            disabled={true}
            name="contract_start"
            mb4="mb-4"
            labelHtmlFor="contract_start"
            labelClassName={` ${stylesRequestData["form-label"]} form-label`}
            labelText={"تاريخ بداية التعاقد"}
            inputType="text"
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="contract_start_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          />
        </div>
      ) : (
        <div className="col-lg-4 col-sm-6">
          <DatePickerFormatedWithLimit
            name="contractStartDate"
            name_datepicker="contractStartDate"
            mb4="mb-4"
            labelHtmlFor="contractStartDate"
            labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
            labelText="تاريخ بداية التعاقد"
            inputType="datePicker"
            maxDate={
              new Date(
                Moment(contractEndDate)
                  ?.subtract(1, "day")
                  .format("YYYY-MM-DD"),
              ) ||
              new Date(declarationRequest?.created_at) ||
              new Date()
            }
            inputClassName="form-control"
            inputID="contract_start_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.contract_start}
            value={contractStartDate}
            placeholderText="تاريخ بداية التعاقد"
            onChange={handleDateChange}
            isDisabled={
              declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
            }
          />
        </div>
      )}
      {declarationRequest?.viewMode ||
      declarationRequest?.isUnitViewMode ||
      !contractStartDate ? (
        <div className="col-lg-4 col-sm-6">
          <InputElement
            value={declarationRequest?.unit?.contract_end}
            disabled={true}
            name="contract_end"
            mb4="mb-4"
            labelHtmlFor="contract_end"
            labelClassName={` ${stylesRequestData["form-label"]} form-label`}
            labelText={"تاريخ نهاية التعاقد"}
            inputType="text"
            inputClassName={`${stylesRequestData["form-control"]} form-control`}
            inputID="contract_end_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
          />
        </div>
      ) : (
        <div className="col-lg-4 col-sm-6">
          <DatePickerFormatedWithLimit
            name="contractEndDate"
            name_datepicker="contractEndDate"
            mb4="mb-4"
            labelHtmlFor="contractEndDate"
            labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
            labelText="تاريخ نهاية التعاقد"
            inputType="datePicker"
            maxDate={Moment().add(50, "years")}
            minDate={Moment(contractStartDate)
              ?.add(1, "day")
              .format("YYYY-MM-DD")}
            inputClassName="form-control"
            inputID="contract_end_input"
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.contract_end}
            value={contractEndDate}
            placeholderText="تاريخ نهاية التعاقد"
            onChange={handleDateChange}
            isDisabled={
              declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
            }
          />
        </div>
      )}

      {!declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode && (
        <>
          <div className="col-md-4">
            <InputElement
              fileInputRef={deedOfExploitationFileInputRef}
              mb4="mb-4"
              key={`agency-${fileInputKeys.deed_of_exploitation}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="deed_of_exploitation"
              labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
              labelText="سند الإنتفاع أو الإستغلال"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="deed_of_exploitation_input"
              name="deed_of_exploitation"
              fileName={
                declarationRequest?.unit?.deed_of_exploitation
                  ?.original_file_name || "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["deed_of_exploitation"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.deed_of_exploitation !== null
                  ? true
                  : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit(
                  "",
                  "",
                  "deed_of_exploitation",
                  null,
                );
                if (deedOfExploitationFileInputRef?.current) {
                  deedOfExploitationFileInputRef.current.value = null;
                }
              }}
            />
          </div>
        </>
      )}

      {(declarationRequest?.viewMode || declarationRequest?.isUnitViewMode) &&
        attachedEssentialDocuments.length > 0 && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الأساسية
            </h4>
            <div className="row">
              {attachedEssentialDocuments.map((document) => (
                <div className="col-md-4" key={document.key}>
                  <label
                    htmlFor={document.key}
                    className={`${stylesRequestData["form-label"]} form-label`}
                  >
                    {document.label}
                  </label>
                  <div className=" col-2-4 d-flex border border-2  rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={document.file?.original_file_name}
                    >
                      {document.file?.original_file_name}
                    </p>
                    <div className="d-flex align-items-center py-2">
                      <span
                        type="button"
                        onClick={() =>
                          handlePreviewFile(document.file?.full_url)
                        }
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-slab-press fa-regular fa-eye fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                      <span
                        type="button"
                        onClick={() => DownloadFile(document.file?.full_url)}
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default MineQuarryForm;
